import React from 'react'
import FormInput from '../../forms/formInput'
import GreenButton from '../../forms/greenButton'
import BlueButton from '../../forms/blueButton'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from 'react';
import ApiUrl from '../../../configTools/apiUrl';

const ListingIntust = ({IntrustAddBox,get_admin_list}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [name,setName] = useState('');
    const [save,setSave] = useState('Save');
  
    function add_admin(){
      const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
        fetch(ApiUrl.API_URL_Intrust, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          },
          body: JSON.stringify({
              name : name
          })
        })
        .then(res=>res.json())
        .then(data =>{
          if(data.success){
            ResetFunction();
            get_admin_list();
            setTimeout(() => {
              toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });

              IntrustAddBox.current.className = 'listing_intrust_add_wrapper';
            }, 500);
          }
          else{
            setTimeout(() => {
              toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
          }
        });
    }
    const ResetFunction = ()=>{
       setName(""); setSave('Save');
    }
  return (
    <div className='listing_intrust_add_wrapper' ref={IntrustAddBox}>
        <div className='listing_intrust_add_container'>
            <div className='listing_intrust_add_close'>
                <button onClick={()=>{
                    IntrustAddBox.current.className = 'listing_intrust_add_wrapper';
                }}>X</button>
            </div>
            <div className='admin_forms_container'>
              <FormInput Lable='Name' Type='text' Placeholder='Enter name' Value={name} setValue={setName}/>
              <div className='admin_forms_row'>
                <div className='admin_col_45'>
                  <GreenButton Value={save} Action={add_admin}/>
                </div>
                <div className='admin_col_10'></div>
                <div className='admin_col_45'>
                  <BlueButton Value='Reset' Action={ResetFunction}/>
                </div>
              </div>
            </div>
        </div>
      <ToastContainer />
    </div>
  )
}

export default ListingIntust
